<script>
import { storeName } from "@/global/variable";
import { VueSpinner } from "vue3-spinners";
import { mapActions } from "vuex";

export default {
  name: "MemberKeyModal",
  components: { VueSpinner },
  data() {
    return {
      apiKey: null,
      secretKey: null,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(storeName.user, ["AC_UPDATE_MEMBER_KEY"]),
    async updateMemberKey() {
      if (!this.apiKey || !this.secretKey) {
        alert("모든 데이터는 필수 입니다.");
        return false;
      }
      if (!confirm("변경내역을 저장하시겠습니까?")) return;

      // TODO : api call

      await this.AC_UPDATE_MEMBER_KEY({
        apiKey: this.apiKey,
        secretKey: this.secretKey,
      });
    },
  },
};
</script>
<template>
  <div class="common-modal-wrap">
    <div class="pc-modal-content">
      <div class="pc-modal-header">
        <h2 class="text-lg font-bold">Api,SecretKey 변경</h2>
        <button @click="$emit('modal-close')" class="text-gray-500">
          닫기
        </button>
      </div>
      <div class="pc-modal-description-wrap">
        <p class="font-bold text-red-500">변경 후, 다시 로그인을 진행합니다.</p>
      </div>

      <div class="px-4 py-2">
        <p class="w-full text-left mb-1 text-gray-400">Api Key</p>
        <div class="mb-4 w-full">
          <input
            type="text"
            class="px-2 py-1 w-full border-b active:outline-none focus:outline-none"
            placeholder="바이낸스 apiKey"
            v-model="apiKey"
          />
        </div>
        <p class="w-full text-left mb-1 text-gray-400">Secret Key</p>
        <div class="w-full">
          <input
            type="text"
            class="px-2 py-1 w-full border-b active:outline-none focus:outline-none"
            placeholder="바이낸스 SecretKey"
            v-model="secretKey"
          />
        </div>
      </div>

      <div class="p-4">
        <button
          @click="updateMemberKey"
          class="bg-blue-500 text-white w-full py-2 rounded"
          v-bind:disabled="isLoading"
        >
          <div v-if="isLoading" class="flex justify-center">
            <VueSpinner size="20"></VueSpinner>
          </div>

          <span v-else>저장</span>
        </button>
      </div>
    </div>
  </div>
</template>
